module.exports = __webpack_public_path__ + "static/media/Illus-SupplyChain.c1b14943.png";